/**
 * Lithuanian grammar utilities for proper noun declension
 */

/**
 * Get the proper Lithuanian form based on number
 * @param {number} count - The number to check
 * @param {string} singular - Singular nominative form (e.g., "filmas")
 * @param {string} plural - Plural nominative form (e.g., "filmai")
 * @param {string} genitive - Genitive plural form (e.g., "filmų")
 * @returns {string} The correct form based on Lithuanian grammar rules
 */
export function getLithuanianForm(count, singular, plural, genitive) {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  // Ends in 1 (but not 11): singular nominative
  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return singular;
  }
  // Ends in 2-9 (but not 12-19): plural nominative
  if (lastDigit >= 2 && lastDigit <= 9 && (lastTwoDigits < 12 || lastTwoDigits > 19)) {
    return plural;
  }
  // All other cases: genitive plural
  return genitive;
}

/**
 * Get "Rodoma/Rodomi/Rodomas" text for showing items
 * @param {number} count - Number of items
 * @param {string} type - Type of media: 'movie', 'tv', 'result', or 'item'
 * @returns {string} Properly formatted Lithuanian text
 */
export function getShowingText(count, type = 'item') {
  let nounForm, verbForm;
  
  switch (type) {
    case 'movie':
      nounForm = getLithuanianForm(count, 'filmas', 'filmai', 'filmų');
      verbForm = getLithuanianForm(count, 'rodomas', 'rodomi', 'rodoma');
      break;
    case 'tv':
      nounForm = getLithuanianForm(count, 'serialas', 'serialai', 'serialų');
      verbForm = getLithuanianForm(count, 'rodomas', 'rodomi', 'rodoma');
      break;
    case 'result':
      nounForm = getLithuanianForm(count, 'rezultatas', 'rezultatai', 'rezultatų');
      verbForm = getLithuanianForm(count, 'rodomas', 'rodomi', 'rodoma');
      break;
    case 'item':
    default:
      nounForm = getLithuanianForm(count, 'elementas', 'elementai', 'elementų');
      verbForm = getLithuanianForm(count, 'rodomas', 'rodomi', 'rodoma');
      break;
  }
  
  return `${verbForm.charAt(0).toUpperCase() + verbForm.slice(1)} ${count} ${nounForm}`;
}

